import { useStore as getStore } from "../../utils/useStore.js";
import marketingFactory from "./marketingFactory.js";

const initialState = () => ({
  wasShown: false,
  data: null,
});

const [MarketingProvider, useMarketing, withMarketing] = getStore(
  marketingFactory,
  initialState,
  "Marketing"
);

export const marketingInitState = initialState();

export { useMarketing, MarketingProvider, withMarketing };

export default MarketingProvider;
